export default "__VITE_ASSET__BsacCoGI__"